// Editor.jsx
import { useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Paragraph from "@editorjs/paragraph";
import Table from "@editorjs/table";
import ImageTool from "@editorjs/image";
import CodeTool from "@editorjs/code";
import Quote from "@editorjs/quote";
import Delimiter from "@editorjs/delimiter";
import Checklist from "@editorjs/checklist";

const Editor = forwardRef(({ onChange }, ref) => {
  const holderId = "editor-js-holder";
  const instanceRef = useRef(null);

  useEffect(() => {
    const editor = new EditorJS({
      holder: holderId,
      autofocus: true,
      onChange: async () => {
        const data = await editor.save();
        onChange(data);
      },
      tools: {
        paragraph: { class: Paragraph, inlineToolbar: true },
        header: { class: Header, inlineToolbar: true },
        list: { class: List, inlineToolbar: true },
        table: { class: Table, inlineToolbar: true },
        image: {
          class: ImageTool,
          config: {
            endpoints: {
              byFile: `${import.meta.env.VITE_API_URL}/uploadFile`,
            },
          },
        },
        code: CodeTool,
        quote: { class: Quote, inlineToolbar: true },
        delimiter: Delimiter,
        checklist: { class: Checklist, inlineToolbar: true },
      },
    });

    instanceRef.current = editor;

    return () => {
      if (instanceRef.current?.destroy) {
        instanceRef.current.destroy();
        instanceRef.current = null;
      }
    };
  }, []);

  // Expose clear method
  useImperativeHandle(ref, () => ({
    clear: async () => {
      await instanceRef.current?.clear();
      onChange({ blocks: [] });
    },
  }));

  return (
    <div
      id={holderId}
      className="bg-[#143E55] p-3 rounded border border-[#22BEFF33] min-h-[200px] text-white"
    />
  );
});

export default Editor;
